import React from 'react';
import loader from '../assets/loader.gif';

export default function Screen() {
    return <img src={loader} className={`loader`} />;
}
